module.exports = __webpack_public_path__ + "img/fast-backward.1b693342.svg";